import win_sound from './sounds/win.mp3';
import collect_sound from './sounds/collect.mp3';

let audioContext = null;
let winBuffer = null;
let collectBuffer = null;

function getAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
}

async function loadSound(url) {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  return getAudioContext().decodeAudioData(arrayBuffer);
}

loadSound(win_sound).then(buffer => { winBuffer = buffer; });
loadSound(collect_sound).then(buffer => { collectBuffer = buffer; });

function playBuffer(buffer, volume = 1.0, playbackRate = 1.0) {
  if (!buffer) return;
  
  const ctx = getAudioContext();
  const source = ctx.createBufferSource();
  const gainNode = ctx.createGain();

  source.buffer = buffer;
  source.playbackRate.value = playbackRate;
  gainNode.gain.value = volume;

  source.connect(gainNode).connect(ctx.destination);
  source.start(0);
}

export function playWinSound() {
  playBuffer(winBuffer);
}

export function playCollectSound() {
  const playbackRate = 1.0 + (Math.random() - 0.5) * 0.02;
  playBuffer(collectBuffer, 0.05, playbackRate);
}

export function unlockAudio() {
  const ctx = getAudioContext();
  if (ctx.state === 'suspended') {
    ctx.resume();
  }
}

document.addEventListener('touchstart', unlockAudio, { once: true });
document.addEventListener('click', unlockAudio, { once: true });